import { Injectable } from "@angular/core";

import { PickerController, ModalController } from "@ionic/angular";

export interface ModalOptions {
  content: any; //组件
  model?: ""; //multiple
  title?: string; //标题
  class?: string;
}
@Injectable()
export class KreFormIonDialogService {
  constructor(protected modalController: ModalController) {}

  public async CreateModelDialog(
    modalOptions: ModalOptions,
    params: any,
    callback: any
  ) {
    const modal = await this.modalController.create({
      component: modalOptions.content,
      cssClass: modalOptions.class,
      componentProps: {
        ...params,
      },
      mode: "ios",
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    callback(data, modal);
  }
}
